/**
 * Es kann sein, dass die app in einem Unterordner läuft (/konfigurator)
 * Hiermit können die Pfade aufgelöst werden (z.B. für GLTF-Dateien
 */
export const publicPath = (path: string): string => process.env.PUBLIC_URL + path;
